import { OnInit, Component, Input } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TurnoUACModel } from 'src/app/models/turnoUAC.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';

@Component({
    selector: 'app-consulta-turnos-UAC',
    templateUrl: './consulta-turnos-UAC.component.html',
    styleUrls: ['./atender-ciudadano-UAC.component.scss']
})

export class ConsultaTurnosUACComponent implements OnInit {

    public turnosTramite: TurnoUACModel[];
    @Input() ventanillaActual: any;
    @Input() sedeActual: any;
    @Input() idTramite: any;
    constructor(private alertService: AlertService, private activeModal: NgbActiveModal
        , private global: GlobalService, private spiner: NgxSpinnerService, private urlService: UrlService) {
        this.turnosTramite = [];
    }

    ngOnInit() {
        this.consultarTurnosPendientesDevolucion();
    }

    /**
   * 
   */
    close() {
        this.activeModal.close();
    }

    /**
     * @author fromero
     * consulta los turnos que estàn pendinetes de devoluciuòn de documentos
     */
    consultarTurnosPendientesDevolucion() {
        this.spiner.show();
        const serviceProvider = 'consultaTurnoPendientesDocs';
        var queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['numeroVentanilla', this.ventanillaActual]);
        queryParams.push(['idTramite', this.idTramite.idTramite]);
        queryParams.push(['sede', this.sedeActual]);
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        this.global.getGenerico(url).subscribe(
            data => {
                this.turnosTramite = data;
                this.spiner.hide();
            }, err => {
                this.cathException(err.error.message);
            }
        );
    }


    llamarTurno(turno) {
        this.activeModal.close(turno);
    }
    /**
   * 
   * @param error 
   */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spiner.hide();
    }

}